var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBagFill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 0.25H7.75C8.08152 0.25 8.39946 0.381696 8.63388 0.616116C8.8683 0.850537 9 1.16848 9 1.5V2.75H11.5C11.8315 2.75 12.1495 2.8817 12.3839 3.11612C12.6183 3.35054 12.75 3.66848 12.75 4V10.875C12.75 11.2065 12.6183 11.5245 12.3839 11.7589C12.1495 11.9933 11.8315 12.125 11.5 12.125H1.5C0.80625 12.125 0.25 11.5625 0.25 10.875V4C0.25 3.30625 0.80625 2.75 1.5 2.75H4V1.5C4 0.80625 4.55625 0.25 5.25 0.25ZM7.75 2.75V1.5H5.25V2.75H7.75Z",
    fill: "black",
    fillOpacity: 0.66
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagFill);
export default __webpack_public_path__ + "static/media/BagFill.541784d1.svg";
export { ForwardRef as ReactComponent };